import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './CategoriesSlider.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { useDeviceDetect } from '../../utils/use-device-detect'
import i18next from 'i18next'
import { ICategory } from '../../types/categories'
import { useTranslation } from 'react-i18next'
import CategoryCountdown from './CategoryCountdown'

type Props = {
  data: ICategory[]
}

const c = 'categories-slider'

const CategoriesSlider = (props: Props) => {
  const { isMobile } = useDeviceDetect()
  const { t, i18n } = useTranslation()
  const newLabel = t('NEW')
  const newBadgeClass = `${c}__corner-new${newLabel.length > 3 ? ` ${c}__corner-new--long` : ''}`

  const getTranslatedName = (item: ICategory) => {
    if (i18n.language === 'ru' && item?.ru_name) {
      return item.ru_name
    }

    return item.name
  }

  const SlickArrowLeft = ({
    currentSlide,
    slideCount,
    ...props
  }: {
    currentSlide?: number
    slideCount?: number
    [key: string]: unknown
  }) => (
    <FontAwesomeIcon
      icon={faChevronLeft}
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden='true'
      aria-disabled={currentSlide === 0 ? true : false}
      type='button'
    />
  )

  const SlickArrowRight = ({
    currentSlide,
    slideCount,
    ...props
  }: {
    currentSlide?: number
    slideCount?: number
    [key: string]: unknown
  }) => (
    <FontAwesomeIcon
      icon={faChevronRight}
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount! - 1 ? ' slick-disabled' : '')
      }
      aria-hidden='true'
      aria-disabled={currentSlide === slideCount! - 1 ? true : false}
      type='button'
    />
  )

  const slidesToShow = isMobile
    ? Math.min(2, props.data.length)
    : Math.min(props.data.length > 4 ? 4 : props.data.length, props.data.length)
  const needsCarousel = props.data.length > slidesToShow

  const settings = {
    infinite: needsCarousel,
    speed: 500,
    slidesToShow,
    swipeToSlide: true,
    centerMode: needsCarousel,
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,
  }

  function handleClick(category_id: string) {
    const section = document.getElementById(`category-${category_id}`)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <div className={c}>
      {isMobile ? (
        <div className={`${c}__categories`}>
          {props?.data?.map((item) => (
            <div
              key={item._id}
              className={`${c}__categories-item`}
              onClick={() => handleClick(item._id)}
            >
              {item.isNew && <span className={newBadgeClass}>{newLabel}</span>}
              <span>{getTranslatedName(item)}</span>
              {item.specialOfferEnd && (
                <CategoryCountdown
                  endDate={item.specialOfferEnd}
                  className='slider-countdown'
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <Slider {...settings}>
          {props?.data?.map((item) => (
            <div
              key={item._id}
              className='slider-item'
              onClick={() => handleClick(item._id)}
            >
              {item.isNew && <span className={newBadgeClass}>{newLabel}</span>}
              <span>{getTranslatedName(item)}</span>
              {item.specialOfferEnd && (
                <CategoryCountdown
                  endDate={item.specialOfferEnd}
                  className='slider-countdown'
                />
              )}
            </div>
          ))}
        </Slider>
      )}
    </div>
  )
}

export default CategoriesSlider
